import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter } from "react-router-dom";

import { StytchB2BProvider } from "@stytch/react/b2b";
import { StytchB2BUIClient } from "@stytch/vanilla-js/b2b";

import { QueryClient, QueryClientProvider } from "react-query";

import App from "./App";
import reportWebVitals from "./reportWebVitals";

import { CssVarsProvider } from "@mui/joy/styles";
import CssBaseline from "@mui/joy/CssBaseline";

import { extendTheme } from "@mui/joy";

import "@fontsource/inter";

const stytch = new StytchB2BUIClient(process.env.REACT_APP_STYTCH_TOKEN!);

const queryClient = new QueryClient();

const root = ReactDOM.createRoot(document.getElementById("root") as HTMLElement);

const theme = extendTheme({
    colorSchemes: {
        light: {
            palette: {
                primary: {
                    "50": "#d3e0fb",
                    "100": "#d3e0fb",
                    "200": "#a8c1f7",
                    "300": "#7ca1f3",
                    "400": "#5182ef",
                    "500": "#2563eb",
                    "600": "#1e4fbc",
                    "700": "#163b8d",
                    "800": "#0f285e",
                    "900": "#07142f",
                },
            },
        },
    },
    fontFamily: {
        body: "'Inter', system-ui, var(--joy-fontFamily-fallback)",
    },
});
root.render(
    // <React.StrictMode>
    <StytchB2BProvider stytch={stytch}>
        <BrowserRouter>
            <QueryClientProvider client={queryClient}>
                <CssVarsProvider theme={theme}>
                    <CssBaseline />
                    <App />
                </CssVarsProvider>
            </QueryClientProvider>
        </BrowserRouter>
    </StytchB2BProvider>,
    // </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
